import { ALL_QUEUE_ID } from '@/enum/queueDashboardStatistics'

export default {
    data() {
        return {
            parameterName: '{|queue_list|}'
        }
    },
    computed: {
        valueJson () {
            let valueJson = undefined
            this.data.WidgetConfig.forEach(el => {
                if (el.ParameterName === this.parameterName) {
                    valueJson = el.WidgetParameterValueJson || {}
                }
            })
            return valueJson
        },
    },
    methods: {
        entitiesFilter (entities, key = 'queue_id') {
            if (this.valueJson) {
                const entityPositive = this.valueJson['EntityPositive'] || []
                const entityNegative = this.valueJson['EntityNegative'] || []

                if (entityPositive && entityPositive.length) {
                    return entities.filter(e => entityPositive.includes(e[key]) || (key === 'queue_id' && e[key] === ALL_QUEUE_ID))
                } else if (entityNegative && entityNegative.length) {
                    return entities.filter(e => !entityNegative.includes(e[key]))
                }
            }
            return entities
        },
    }
}
